<template>
  <gw-entity-filter-item :display-text="displayText" :property-name="propertyName"
    representation-field="codigo" :search="finder"
      :selection-support="listing"
      :find-values="findValues">
    <template slot="item" slot-scope="{entity}">
      <div>
        <strong>{{$t('UnidadeNegocio.ui.filterItem.nome')}} </strong>
        <span>{{entity.nome}}</span><br/>
        <strong>{{$t('UnidadeNegocio.ui.filterItem.codigoA7')}} </strong>
        <span>{{entity.codigoclientealpha7}}</span><br/>
        <strong>{{$t('UnidadeNegocio.ui.filterItem.cnpj')}} </strong>
        <span>{{entity.cnpj}}</span><br/>
      </div>
    </template>
  </gw-entity-filter-item>
</template>

<script>
import { GwEntityFilterItem, GwCustomFilterItemMixin } from 'guaxinim-web'
import UnidadeNegocioRestResource from './UnidadeNegocioRestResource'
import A7UnidadeNegocioListing from './A7UnidadeNegocioListing'

export default {
  name: 'a7-unidade-negocio-filter-item',
  mixins: [GwCustomFilterItemMixin],
  components: {
    GwEntityFilterItem,
    GwCustomFilterItemMixin,
    A7UnidadeNegocioListing
  },
  data() {
    return {
      listing: A7UnidadeNegocioListing
    }
  },
  methods: {
    finder(pattern) {
      if (!pattern) return null
      return UnidadeNegocioRestResource.
        findUnidadeNegocioFinderDTO(pattern, 10)
    },
    findValues(ids) {
      return UnidadeNegocioRestResource.findEntities(ids)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
